import { useSelector } from 'react-redux';

export function useAuth() {
  const { isLoggedIn, token } = useSelector((state) => state.auth);

  return !!isLoggedIn && !!token;
}
